// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".table-rekap td {\n  border-top: 1px solid;\n  border-bottom: 1px solid;;\n  font-size: 22px;\n}", "",{"version":3,"sources":["webpack://src/components/page-content/admin/css/rekapitulasi.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,eAAe;AACjB","sourcesContent":[".table-rekap td {\n  border-top: 1px solid;\n  border-bottom: 1px solid;;\n  font-size: 22px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
